import { useDispatch, useReduxState } from 'hooks';
import { getMessageWithPlaceholders } from 'shared-locales';
import api from 'api';
import { actions } from 'store';
import { ConfirmButton, MoreOptions } from 'components/common';
import { UsersSendMessage } from 'components/users';
import { PathParticipantsExportExcel } from '.';

import type { UserSelectionParams } from 'lib/users/getSelectedUsers';

interface Props {
  userIds: number[];
  userSelectionParams: UserSelectionParams;
  updateUsers: () => Promise<void>;
}

const PathParticipantsHeaderContent = ({
  userIds,
  userSelectionParams,
  updateUsers
}: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { path },
    serverConfig: { adminUrl }
  } = useReduxState();

  const handleMarkComplete = async () => {
    try {
      let numberOfNewCompletions = 0;
      let numberOfUpdatedCompletions = 0;
      if (userIds.length) {
        const response = await api.post(
          `/admin/paths/${path.id}/check-for-completions`,
          { userIds: userIds }
        );

        numberOfNewCompletions = response.data.newPathCompletions;
        numberOfUpdatedCompletions = response.data.updatedPathCompletions;

        await updateUsers();
      }

      dispatch(
        actions.addNotice({
          text:
            getMessageWithPlaceholders({
              message: messages.completionManuallyPathNewCompletions,
              placeholders: { numberOfNewCompletions }
            }) +
            '<br>' +
            getMessageWithPlaceholders({
              message: messages.completionManuallyPathUpdatedCompletions,
              placeholders: { numberOfUpdatedCompletions }
            }),
          type: 'success'
        })
      );

      return true;
    } catch (err) {
      return false;
    }
  };

  return (
    <div style={{ alignItems: 'center', display: 'flex', gap: 10 }}>
      <UsersSendMessage
        buttonSize="header"
        emailButtonTarget={`${adminUrl}/paths/${path.id}`}
        id="path-participants-header-send-message"
        userSelectionParams={userSelectionParams}
      />

      <MoreOptions category="light">
        <>
          <PathParticipantsExportExcel userIds={userIds} />

          <ConfirmButton
            actionText={messages.commonConfirm}
            buttonIcon="check"
            buttonText={messages.completionManuallyPath}
            confirmText={messages.completionManuallyPathDescription}
            confirmTitle={messages.completionManuallyPath}
            disabled={!userIds.length}
            onConfirm={handleMarkComplete}
          />
        </>
      </MoreOptions>
    </div>
  );
};

export default PathParticipantsHeaderContent;
